import axios from "axios";
import { getHeaders, getURl } from "./core";

let url = `${getURl()}/overtime/v1`;

export function getMany({
  offset = 0,
  limit = 15,
  search = "",
  status,
  rangFilter = "",
}) {
  let leaveUrl = `${url}/lists?offset=${offset}&limit=${limit}&search=${search}&rangFilter=${rangFilter}`;

  if (status) leaveUrl += `&status=${status}`;

  const result = axios({
    method: "GET",
    headers: getHeaders(),
    url: leaveUrl,
  });
  return new Promise((resolve, reject) => {
    result
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}

export function getOne(id) {
  const result = axios({
    method: "GET",
    url: `${url}/detail/${id}`,
    headers: getHeaders(),
  });
  return new Promise((resolve, reject) => {
    result
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
}

export function approveAndRejectOvertimeReuest(id, data) {
  return axios({
    method: "PUT",
    url: `${url}/approve/${id}`,
    headers: getHeaders(),
    data,
  });
}

export function createOvertimeRequest(data) {
  return axios({
    method: "POST",
    url: `${url}/request`,
    headers: getHeaders(),
    data,
  });
}
